import { render, staticRenderFns } from "./StatisticalCharts.vue?vue&type=template&id=6a44b2f4&"
import script from "./StatisticalCharts.vue?vue&type=script&lang=js&"
export * from "./StatisticalCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports